module.exports = __webpack_public_path__ + "img/braintree.6cb4dfc0.jpg";